var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReturnIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11587",
    "data-name": "Group 11587",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.534,
    height: 15.836,
    viewBox: "0 0 18.534 15.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3134",
    "data-name": "Rectangle 3134",
    width: 18.534,
    height: 15.836,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9242",
    "data-name": "Group 9242",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M15.934,12.051a2.234,2.234,0,0,1,.536,1.608,2.409,2.409,0,0,1-.611,1.444,2.307,2.307,0,0,1-2.567.552,2.33,2.33,0,0,1-1.411-1.908,2.252,2.252,0,0,1,.2-1.217H10.311a2.524,2.524,0,0,1,.212.71,2.176,2.176,0,0,1-.287,1.415,2.435,2.435,0,0,1-.447.588,1.926,1.926,0,0,1-.618.4,2.271,2.271,0,0,1-2.578-.517A2.244,2.244,0,0,1,5.936,13.6a2.155,2.155,0,0,1,.542-1.559l-.19-.14A3.231,3.231,0,0,1,4.961,9.8q-.084-.465-.156-.933c-.08-.518-.155-1.037-.234-1.556-.072-.467-.148-.934-.221-1.4-.045-.291-.082-.584-.13-.875-.1-.6-.165-1.209-.308-1.8-.1-.43-.213-.858-.324-1.285a1.267,1.267,0,0,0-.1-.28.668.668,0,0,0-.591-.35c-.041,0-.082,0-.124,0-.673,0-1.346,0-2.019,0a1.02,1.02,0,0,1-.235-.024A.656.656,0,0,1,0,.6.6.6,0,0,1,.533.023,1.763,1.763,0,0,1,.8,0Q1.839,0,2.88,0A1.953,1.953,0,0,1,3.8.2,2,2,0,0,1,4.852,1.548q.128.508.254,1.017a.083.083,0,0,0,.095.073c.031,0,.062,0,.093,0q2.58,0,5.161,0a1.063,1.063,0,0,1,.313.046A.605.605,0,0,1,11.2,3.2a.615.615,0,0,1-.268.608.737.737,0,0,1-.413.14c-.034,0-.069,0-.1,0H5.519c-.043,0-.087,0-.144.006.014.092.026.172.039.252q.081.513.162,1.026c.068.43.136.86.2,1.29s.128.861.193,1.292q.106.691.217,1.382a4.011,4.011,0,0,0,.1.545,1.967,1.967,0,0,0,1.447,1.4,2.228,2.228,0,0,0,.582.063q2.91,0,5.82,0a2.008,2.008,0,0,0,1.476-.6,1.969,1.969,0,0,0,.553-1.1c.073-.457.14-.915.21-1.372.019-.122.037-.244.06-.365a.658.658,0,0,1,1.3.189c-.037.316-.091.631-.138.946-.038.254-.074.509-.116.762a3.644,3.644,0,0,1-.564,1.445,3.251,3.251,0,0,1-.838.828c-.032.02-.062.043-.092.066s-.031.027-.056.049m-.781,1.475a.984.984,0,0,0-1.967-.039.984.984,0,1,0,1.967.039M8.237,12.54a.977.977,0,1,0,.979.992.972.972,0,0,0-.979-.992",
    transform: "translate(0 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M132.938,86.832h-4.786a.5.5,0,1,1,0-1h4.786a.5.5,0,1,1,0,1",
    transform: "translate(-114.903 -83.031)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M112.8,60.6a.5.5,0,0,1-.267-.921l2.224-1.4a.5.5,0,0,1,.533.844l-2.224,1.4a.5.5,0,0,1-.266.077",
    transform: "translate(-100.327 -56.8)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M115.019,88.038a.5.5,0,0,1-.266-.077l-2.224-1.4a.5.5,0,0,1,.533-.844l2.224,1.4a.5.5,0,0,1-.267.921",
    transform: "translate(-100.326 -82.844)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIcon);
export default __webpack_public_path__ + "static/media/return-icon.5b1ff3139459b90348a9d1de43a3385a.svg";
export { ForwardRef as ReactComponent };